module.exports = __webpack_public_path__ + "static/img/图片1.f0b85d32.png";